import { videoEvaluator } from '../utils/video-evaluator';
var RelatedVideosSpotController = (function () {
    function RelatedVideosSpotController($scope, productContextService) {
        this.$scope = $scope;
        this.productContextService = productContextService;
    }
    RelatedVideosSpotController.prototype.$onInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) { _this.$scope.group = group; });
        this.$scope.$on('related-videos', function (event, videos) {
            if (videos === void 0) { videos = []; }
            _this.$scope.videos = videos.filter(videoEvaluator);
        });
    };
    RelatedVideosSpotController.$inject = ['$scope', 'productContextService'];
    return RelatedVideosSpotController;
}());
export { RelatedVideosSpotController };
